import { FC, SVGAttributes } from "react";

const PatternIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="8" cy="8" r="3" fill="black" />
    <circle cx="8" cy="24" r="3" fill="black" />
    <circle cx="16" cy="8" r="2" fill="black" />
    <circle cx="16" cy="24" r="2" fill="black" />
    <circle cx="8" cy="16" r="2" fill="black" />
    <circle cx="24" cy="16" r="2" fill="black" />
    <circle cx="24" cy="8" r="3" fill="black" />
    <circle cx="24" cy="24" r="3" fill="black" />
    <circle cx="16" cy="16" r="3" fill="black" />
  </svg>
);

export { PatternIcon };
